module.exports = fox._r("fonts/promo-social-icon-set.eot?6587jk", __webpack_public_path__ + "fonts/fMAT2qu.eot");


//////////////////
// WEBPACK FOOTER
// ./fonts/promo-social-icon-set.eot?6587jk
// module id = 66
// module chunks = 2